import { Trans, useTranslation } from 'next-i18next';
import { BoltSmallRectangleColorMintIcon, BoltSmallRectangleColorVioletIcon } from '@/icons';
import { usePrices } from '@/module/payment/hooks';
import { useCountryCode } from '@/shared/hooks';
import { type PlanType as _PlanType } from '@/types';
import { cn } from '@/utils/tailwind.util';
import { RadioOff } from './RadioOff';
import { RadioOn } from './RadioOn';
type PlanType = Exclude<_PlanType, 'FREE'>;
interface SelectableCardProps {
  planType: PlanType;
  isSelected: boolean;
  onSelect?: (planType: PlanType) => void;
}
export const SelectableCard = ({
  planType,
  isSelected,
  onSelect
}: SelectableCardProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    countryCode
  } = useCountryCode();
  return <article className={cn('bg-white rounded-xl cursor-pointer p-lg flex gap-md items-center', isSelected ? 'outline-[3px] outline-strong shadow-md outline' : 'border-alternative border')} onClick={() => onSelect?.(planType)} data-sentry-component="SelectableCard" data-sentry-source-file="SelectableCard.tsx">
      {isSelected ? <RadioOn /> : <RadioOff />}

      <div className="w-full pr-4xs">
        <header className="flex items-center gap-2xs">
          {planType === 'BASIC' ? <BoltSmallRectangleColorMintIcon size="md" /> : <BoltSmallRectangleColorVioletIcon size="md" />}
          <h3 className="text-heading-lg-extrabold">
            {planType === 'BASIC' ? 'Basic' : 'Pro'}
          </h3>
        </header>
        <div className="mb-md mt-sm">
          <Price planType={planType} countryCode={countryCode} data-sentry-element="Price" data-sentry-source-file="SelectableCard.tsx" />
        </div>
        <p className="text-body-md-medium text-neutral">
          {planType === 'BASIC' ? t('common:pricing.basic.description') : t('common:pricing.pro.description')}
        </p>
      </div>
    </article>;
};
interface PriceProps {
  planType: PlanType;
  countryCode: string;
}
const Price = ({
  planType,
  countryCode
}: PriceProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    finalPrice
  } = usePrices({
    countryCode,
    planType
  });
  return <div className="flex items-end gap-xs" data-sentry-component="Price" data-sentry-source-file="SelectableCard.tsx">
      {(() => {
      if (countryCode === 'KR') {
        return <>
              <strong className="text-heading-lg-extrabold">
                ₩{finalPrice?.toLocaleString()}
              </strong>
              <span className="pb-3xs text-body-sm-medium text-alternative">
                <Trans t={t} i18nKey="common:pricing.perTeacherPerMonth" components={{
              Br: <br className="hidden" />
            }} />
              </span>
            </>;
      }
      return <>
            <strong className="text-heading-lg-extrabold">
              ${finalPrice?.toLocaleString()}
              <span className="text-body-lg-bold">(USD)</span>
            </strong>
            <span className="pb-3xs text-body-sm-medium text-alternative">
              <Trans i18nKey="common:pricing.perTeacherPerMonth" components={{
            Br: <br className="hidden" />
          }} />
            </span>
          </>;
    })()}
    </div>;
};